import { render, staticRenderFns } from "./MyInfoDialogComponent.vue?vue&type=template&id=6bab94c4&scoped=true"
import script from "./MyInfoDialogComponent.vue?vue&type=script&lang=js"
export * from "./MyInfoDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab94c4",
  null
  
)

export default component.exports